import { Injectable } from '@angular/core';
import { Configuration } from './configuration.model';

@Injectable()
export class ConfigurationService {
    public configuration: Configuration;
}



// WEBPACK FOOTER //
// ./src/app/shared/configuration.service.ts